import React, {Fragment} from 'react';
import {Grid,Divider} from '@material-ui/core';
import { compose} from "redux";
import { connect } from 'formik';
import _ from 'lodash'
import num from 'numeral';
import styled from 'styled-components';
import numeral from 'numeral';
import {
  ChildSectionTitle,
  SideLabelMoneyInput,
  SideLabelMoneyWithSelectListInput,
  SideLabelCalculatedField,
  SideLabelPercentInput
 } from '../FormSectionComponents';  
 import loanStatuses from 'constants/loanStatuses';
  
const ClosingCostsGrid = styled(Grid)`
  &&& {
    width:700px;
  }
`
class ClosingCostsChildSection extends React.Component {
  sumClosingCosts = (values) => {
    const { 
      originationFeeAmount,
      brokerFeeAmount,
      lenderLegalFeeAmount,
      borrowerLegalFeeAmount,
      inspectionFeeAmount,
      appraisalFeeAmount,
      rateLockFeeAmount,
      hedgeFeeAmount,
      titleAmount,
      otherAmount} = values.closingCosts;                  
    return +originationFeeAmount + 
      +brokerFeeAmount + 
      +lenderLegalFeeAmount + 
      +borrowerLegalFeeAmount + 
      +inspectionFeeAmount + 
      +appraisalFeeAmount + 
      +rateLockFeeAmount +
      +hedgeFeeAmount +
      +titleAmount + 
      +otherAmount;

  }
  render(){
    const {formik, isEditing, brokerList, borrowerCounselList, lenderCounselList} = this.props;
    const sortedBrokerList = _.sortBy(brokerList, 'name');
    const sortedBorrowerCounselList = _.sortBy(borrowerCounselList, 'name');
    const sortedLenderCounselList = _.sortBy(lenderCounselList, 'name');
    
    
    const loanStatusId = _.get(formik.values, "details.loanStatusId");
    const isQuote = loanStatusId !== loanStatuses.CLOSED_LOAN && loanStatusId !== loanStatuses.PAID_OFF;
    const { values } = formik;
    const { details } = values;
    if(!details) return null;    

    
    return (
      <Fragment>
        <div id="loan_section_closing_costs">
        <ChildSectionTitle>Closing Costs</ChildSectionTitle>
        <ClosingCostsGrid container alignItems="center" direction="column">

        {isQuote &&
          <>
            <SideLabelPercentInput label="Origination Fees" placeholder="Origination Fees" fieldName="closingCosts.originationFeePercent" isDisabled={!isEditing} decimalScale={2} />
            <SideLabelPercentInput label="Extension Fees" placeholder="Extension Fees" fieldName="extensionTerms.extensionFeePercent" isDisabled={!isEditing} decimalScale={2} />
            <SideLabelPercentInput label="Broker Fees" placeholder="Broker Fees" fieldName="closingCosts.brokerFeePercent" isDisabled={!isEditing} decimalScale={2} />
            <SideLabelPercentInput label="Exit Fees" placeholder="Exit Fees" fieldName="prepaymentTerms.exitFee" isDisabled={true} decimalScale={2} />
            <SideLabelPercentInput label="Other Fees" placeholder="Other Fees" fieldName="closingCosts.otherFeePercent" isDisabled={!isEditing} decimalScale={2} />
          </>
        }
        {!isQuote &&
          <>
        <SideLabelMoneyInput
            label="Origination Fees"
            fieldName="closingCosts.originationFeeAmount"
            placeholder="Origination Fees"
            isDisabled={!isEditing}
          />
        <SideLabelMoneyWithSelectListInput
            label="Broker Fees"
            moneyFieldName="closingCosts.brokerFeeAmount"
            options={sortedBrokerList}
            ddlFieldName="details.brokerCompanyId"
            selectName="name"
            selectValue="brokerValue"
            moneyPlaceholder="Broker Fees"
            isDisabled={!isEditing}
          />
          <SideLabelMoneyWithSelectListInput
            label="Lender Legal Fees"
            moneyFieldName="closingCosts.lenderLegalFeeAmount"
            options={sortedLenderCounselList}
            ddlFieldName="details.lenderCounselCompanyId"
            selectName="name"
            selectValue="lenderCounselValue"
            moneyPlaceholder="Lender Legal Fees"
            isDisabled={!isEditing}
          />
          <SideLabelMoneyWithSelectListInput
            label="Borrower Legal Fees"
            moneyFieldName="closingCosts.borrowerLegalFeeAmount"
            options={sortedBorrowerCounselList}
            ddlFieldName="details.borrowerCounselCompanyId"
            selectName="name"
            selectValue="borrowerCounselValue"
            moneyPlaceholder="Borrower Legal Fees"
            isDisabled={!isEditing}
          />
          <SideLabelMoneyInput
            label="Inspection Fees"
            fieldName="closingCosts.inspectionFeeAmount"
            placeholder="Inspection Fees"
            isDisabled={!isEditing}
          />
          <SideLabelMoneyInput
            label="Appraisal Fees"
            fieldName="closingCosts.appraisalFeeAmount"
            placeholder="Appraisal Fees"
            isDisabled={!isEditing}
          />
          <SideLabelMoneyInput
            label="Rate Lock"
            fieldName="closingCosts.rateLockFeeAmount"
            placeholder="Rate Lock"
            isDisabled={!isEditing}
          />
          <SideLabelMoneyInput
            label="Hedge Cost"
            fieldName="closingCosts.hedgeFeeAmount"
            placeholder="Hedge Cost"
            isDisabled={!isEditing}
          />
          <SideLabelMoneyInput
            label="Title"
            fieldName="closingCosts.titleAmount"
            placeholder="Title"
            isDisabled={!isEditing}
          />
          <SideLabelMoneyInput
            label="Other Fees"
            fieldName="closingCosts.otherAmount"
            placeholder="Other Fees"
            isDisabled={!isEditing}
          />
          <Divider style={{width:'100%'}}/>
          <SideLabelCalculatedField
            label="Total Closing Costs"
            calculationFunc={ values => {
                if(!values.closingCosts)
                  return "";
                return numeral(this.sumClosingCosts(values)).format('$0,0')
              }
            }
            placeholder="Total Closing Costs"
            isDisabled={!isEditing}/>
          <SideLabelCalculatedField
            label="Closing Cost Ratio"
            calculationFunc={ values => {                
                let loanAmount = _.get(values, 'details.amount')
                if(loanAmount)
                  return numeral(this.sumClosingCosts(values) / loanAmount).format('0.[00]%');
                let closingCostRatio = _.get(values, 'details.closingCostRatio')
                if(closingCostRatio)
                  return numeral(closingCostRatio).format('0.[00]');
                return '-';     
              }
            }
            placeholder="Closing Cost Ratio"
            isDisabled={!isEditing}/>  
          </>
        }          
        </ClosingCostsGrid>
        </div>
      </Fragment>
  )};
}

export default compose(  
  connect,
)(ClosingCostsChildSection);